<script setup>
/* global axios */
// Carteira de Cliente POR CAIXA: sobrescreve o padrão da conta. "Herdar" usa o valor
// configurado em Configurações da conta. Fallback e expiração ficam só na conta.
import { ref, reactive, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  inbox: { type: Object, required: true },
});
const route = useRoute();
const saving = ref(false);
const accountDefault = reactive({ enabled: false, mode: 'priority', auto_assign: false });

// tri-state no front: 'inherit' | 'on' | 'off'  <->  null | true | false
const form = reactive({ enabled: 'inherit', mode: 'inherit', auto_assign: 'inherit' });

const base = computed(
  () =>
    `/api/v1/accounts/${route.params.accountId}/kanban/inboxes/${props.inbox.id}/carteira_config`
);

const triFromBool = v => (v === null || v === undefined ? 'inherit' : v ? 'on' : 'off');
const boolFromTri = v => (v === 'inherit' ? null : v === 'on');
const modeFromApi = v => (v || 'inherit');
const modeToApi = v => (v === 'inherit' ? null : v);

const labelHerdar = b => (b ? 'ligado' : 'desligado');

onMounted(async () => {
  try {
    const { data } = await axios.get(base.value);
    const d = data.data || {};
    form.enabled = triFromBool(d.enabled);
    form.mode = modeFromApi(d.mode);
    form.auto_assign = triFromBool(d.auto_assign);
    Object.assign(accountDefault, d.account_default || {});
  } catch (e) {
    /* sem override ainda → tudo herda */
  }
});

const salvar = async () => {
  saving.value = true;
  try {
    await axios.put(base.value, {
      carteira_inbox_config: {
        enabled: boolFromTri(form.enabled),
        mode: modeToApi(form.mode),
        auto_assign: boolFromTri(form.auto_assign),
      },
    });
    useAlert('Carteira desta caixa salva.');
  } catch (e) {
    useAlert('Não foi possível salvar a carteira desta caixa.');
  } finally {
    saving.value = false;
  }
};
</script>

<template>
  <div class="mt-6 p-4 border border-n-weak rounded-lg">
    <h4 class="text-base font-medium text-n-slate-12">Carteira de Cliente</h4>
    <p class="text-sm text-n-slate-11 mb-3">
      Sobrescreve o padrão da conta só para esta caixa. "Herdar" usa o que está
      configurado em Configurações da conta.
    </p>
    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">Ativar</span>
        <select
          v-model="form.enabled"
          class="w-full rounded-lg border border-n-weak bg-n-alpha-black2 px-3 py-2 text-sm"
        >
          <option value="inherit">
            Herdar da conta ({{ labelHerdar(accountDefault.enabled) }})
          </option>
          <option value="on">Ligado</option>
          <option value="off">Desligado</option>
        </select>
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">Modo</span>
        <select
          v-model="form.mode"
          class="w-full rounded-lg border border-n-weak bg-n-alpha-black2 px-3 py-2 text-sm"
        >
          <option value="inherit">
            Herdar da conta ({{
              accountDefault.mode === 'direct' ? 'direto' : 'prioridade'
            }})
          </option>
          <option value="priority">Prioridade (dono se estiver online)</option>
          <option value="direct">Direto (sempre o dono)</option>
        </select>
      </div>

      <div class="flex flex-col gap-1">
        <span class="text-sm font-medium text-n-slate-12">Auto-carteirizar</span>
        <select
          v-model="form.auto_assign"
          class="w-full rounded-lg border border-n-weak bg-n-alpha-black2 px-3 py-2 text-sm"
        >
          <option value="inherit">
            Herdar da conta ({{ labelHerdar(accountDefault.auto_assign) }})
          </option>
          <option value="on">Ligado</option>
          <option value="off">Desligado</option>
        </select>
      </div>

      <div>
        <woot-button :is-loading="saving" @click="salvar">Salvar</woot-button>
      </div>
    </div>
  </div>
</template>
